/**
 * Reducers specify how the application's state changes in response to actions sent to the store.
 *
 * @see https://redux.js.org/basics/reducers
 */
import { createReducer } from 'reduxsauce';
import { OutbOrd06Types } from './Actions';
import INITIAL_STATE from './InitialState';

export const outbOrd06ResetTimestamp = (state, { currentPage, sorts, filters, pageSize }) => ({
  ...state,
  currentPage: currentPage || state.currentPage,
  sorts: sorts || state.sorts,
  filters: filters || state.filters,
  pageSize: pageSize || state.pageSize,
  timestamp: Date.now()
});

export const outbOrd06FetchOutbOrd06Loading = (state, { boolean }) => ({
  ...state,
  fetchIsLoading: boolean
});

export const outbOrd06FetchOutbOrd06Success = (
  state,
  { documents, currentPage, lastPage, total, pageSize }
) => ({
  ...state,
  documents,
  currentPage,
  lastPage,
  total,
  pageSize
});

export const outbOrd06AddSelectedDocuments = (state, { selectedDocuments }) => {
  const selectIds = state.selectedDocuments.map(value => value.id);
  return {
    ...state,
    selectedDocuments: [
      ...state.selectedDocuments,
      ...selectedDocuments.filter(data => {
        return !selectIds.includes(data.id);
      })
    ]
  };
};

export const outbOrd06RemoveSelectedDocuments = (state, { selectedDocuments }) => {
  const selectIds = selectedDocuments.map(value => value.id);
  return {
    ...state,
    selectedDocuments: state.selectedDocuments.filter(data => {
      return !selectIds.includes(data.id);
    })
  };
};

export const outbOrd06SetWorkspaceVisible = (state, { boolean }) => ({
  ...state,
  workspaceIsVisible: boolean
});

export const outbOrd06CreateOutbOrd06Loading = (state, { boolean }) => ({
  ...state,
  createIsLoading: boolean
});

export const outbOrd06CreateOutbOrd06Success = (state, { newDocuments }) => ({
  ...state,
  timestamp: Date.now(),
  selectedDocuments: [],
  newDocuments
});

export const outbOrd06SetExpandedRows = (state, { expandedRows }) => ({
  ...state,
  expandedRows
});

/**
 * @see https://github.com/infinitered/reduxsauce#createreducer
 */
export const reducer = createReducer(INITIAL_STATE, {
  [OutbOrd06Types.OUTB_ORD06_RESET_TIMESTAMP]: outbOrd06ResetTimestamp,
  [OutbOrd06Types.OUTB_ORD06_FETCH_OUTB_ORD06_LOADING]: outbOrd06FetchOutbOrd06Loading,
  [OutbOrd06Types.OUTB_ORD06_FETCH_OUTB_ORD06_SUCCESS]: outbOrd06FetchOutbOrd06Success,
  [OutbOrd06Types.OUTB_ORD06_ADD_SELECTED_DOCUMENTS]: outbOrd06AddSelectedDocuments,
  [OutbOrd06Types.OUTB_ORD06_REMOVE_SELECTED_DOCUMENTS]: outbOrd06RemoveSelectedDocuments,
  [OutbOrd06Types.OUTB_ORD06_SET_WORKSPACE_VISIBLE]: outbOrd06SetWorkspaceVisible,
  [OutbOrd06Types.OUTB_ORD06_CREATE_OUTB_ORD06_LOADING]: outbOrd06CreateOutbOrd06Loading,
  [OutbOrd06Types.OUTB_ORD06_CREATE_OUTB_ORD06_SUCCESS]: outbOrd06CreateOutbOrd06Success,
  [OutbOrd06Types.OUTB_ORD06_SET_EXPANDED_ROWS]: outbOrd06SetExpandedRows
});
